export interface ITotalCount {
  count: number;
}
